import { ChessWinner } from '@libs/chess/types';

import { components } from '@features/shared/api/game';

export function mapGameWinner(
  apiResult?: components['schemas']['GameResult'],
  clientWinner?: ChessWinner,
): ChessWinner | undefined {
  if (apiResult === 'BlackWin') return 'black';
  if (apiResult === 'WhiteWin') return 'white';
  if (apiResult === 'Draw') return 'draw';

  return clientWinner;
}
